module.exports = __webpack_public_path__ + "img/证书7.0be019df.jpg";